import React from 'react';

/**
 * Whether the region overflows its box, re-measured as either resizes. Shared
 * with the scroll regions that are not a DataTable (the all-time records).
 */
export const useScrollOverflow = (
  ref: React.RefObject<HTMLDivElement | null>,
  table: React.RefObject<HTMLTableElement | null>,
) => {
  const [overflow, setOverflow] = React.useState({x: false, y: false});
  React.useLayoutEffect(() => {
    const el = ref.current;
    if (!el) {
      return undefined;
    }
    const measure = () => {
      const x = el.scrollWidth > el.clientWidth + 1;
      const y = el.scrollHeight > el.clientHeight + 1;
      setOverflow((prev) => (prev.x === x && prev.y === y ? prev : {x, y}));
    };
    measure();
    if (typeof ResizeObserver === 'undefined') {
      return undefined;
    }
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    if (table.current) {
      observer.observe(table.current);
    }
    return () => observer.disconnect();
  }, [ref, table]);
  return overflow;
};
